"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabNames = void 0;
exports.tabNames = {
    cards: 'Cards',
    notes: 'Notes',
    'add-cards': 'Add cards',
    analytics: 'Analytics',
    'cheat-sheet': 'Cheat Sheet',
    share: 'Share',
    settings: 'Settings',
};
exports.default = {
    tabNames: exports.tabNames,
};
//# sourceMappingURL=constants.js.map